"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var AssociateService = /*#__PURE__*/function () {
  function AssociateService() {
    (0, _classCallCheck2.default)(this, AssociateService);
    /**
     * 缓存数据
     *  @type {{ [key: string]: any[] }}
     */
    this.storage = {};
  }
  /**
   * 加载方法，需要先注册
   * @param {string} key
   * @returns {Promise<any[]>}
   */
  return (0, _createClass2.default)(AssociateService, [{
    key: "serviceMethod",
    value: function serviceMethod(key) {
      throw new Error('ServiceMethod 未注册。');
    }
  }, {
    key: "loadData",
    value: function () {
      var _loadData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(key) {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.serviceMethod(key);
            case 2:
              data = _context.sent;
              this.setData(key, data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadData(_x) {
        return _loadData.apply(this, arguments);
      }
      return loadData;
    }()
    /**
     *  注册服务加载方法
     * @param {(key: string) => Promise<any[]>} method
     */
  }, {
    key: "registServiceMethod",
    value: function registServiceMethod(method) {
      this.serviceMethod = method;
    }
    /**
     * 从 storage 中获取数据
     * @param {string} key
     * @returns {Promise<any[]}
     */
  }, {
    key: "getData",
    value: (function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(key) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.storage[key]) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return this.loadData(key);
            case 3:
              return _context2.abrupt("return", this.storage[key]);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getData(_x2) {
        return _getData.apply(this, arguments);
      }
      return getData;
    }()
    /**
     * 设置 storage 数据
     * @param {string} key
     * @param {any[]} data
     */
    )
  }, {
    key: "setData",
    value: function setData(key, data) {
      this.storage[key] = data;
    }
  }]);
}();
var associateService = new AssociateService();
var _default = exports.default = associateService;